import { GATrackingEvent, GATrackingEventPayload } from '~shared/modules/ga-tracking/models';
import { GATrackingEventType } from '~shared/modules/ga-tracking/constants';

export class GaTrackingCreateAccountExperimentEvent implements GATrackingEvent {

  constructor(
    private event: string,
    private category: string) { }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.CreateAccountExperiment;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: this.event,
      category: this.category
    };
  }
}
